import React from 'react';
import { Navigate } from 'react-router-dom';
import { isParentAccount } from './accountRole';

export default function PersonalLearningRoute({ children, parentPath = '/menu' }) {
  return isParentAccount() ? <Navigate to={parentPath} replace /> : children;
}
